import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Space",
    text: "No shared lobbies, no crowded pools. Each residence is a private world — walled gardens, your own pool, your own horizon.",
  },
  {
    num: "02",
    title: "Silence",
    text: "We chose lanes where Bali still whispers — rice-field hush in Berawa, temple quiet in Petitenget, ocean calm at dusk.",
  },
  {
    num: "03",
    title: "Service",
    text: "One message on WhatsApp reaches your concierge. Chefs, drivers, therapists, yachts — arranged quietly, delivered precisely.",
  },
];

export const Story = () => (
  <section id="story" className="py-24 sm:py-32 lg:py-40" data-testid="story-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <p className="mb-5 flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] text-stone-500">
            <span className="h-px w-10 bg-gold" /> Our Story
          </p>
          <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Quiet Luxury,
            <br />
            <span className="italic text-gold">Defined.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <blockquote className="border-l-2 border-gold pl-6 font-serif text-xl font-light italic leading-relaxed text-stone-600 sm:text-2xl">
            "We created BALIBIGVILLAS for the discerning traveler who values
            space, silence, and thoughtful hospitality over resort crowds."
          </blockquote>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px border border-stone-900/10 bg-stone-900/10 sm:grid-cols-3">
        {CHAPTERS.map((ch, i) => (
          <Reveal key={ch.num} delay={0.1 * i} className="h-full">
            <div
              data-testid={`story-chapter-${ch.num}`}
              className="group flex h-full flex-col bg-ivory p-8 transition-colors duration-700 hover:bg-sand sm:p-10"
            >
              <span className="font-serif text-sm italic text-gold">{ch.num}</span>
              <h3 className="mt-8 font-serif text-3xl font-light text-ink">{ch.title}</h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-stone-600">
                {ch.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
